module.exports = "<div class=\"loader\" [ngClass]=\"{'fade-out': hide}\">\r\n  <div class=\"loader-content\" id=\"loader-value\">\r\n  </div>  \r\n</div>\r\n"